import { render, staticRenderFns } from "./CouponValidator.vue?vue&type=template&id=23dc5b4a"
import script from "./CouponValidator.vue?vue&type=script&lang=js"
export * from "./CouponValidator.vue?vue&type=script&lang=js"
import style0 from "./CouponValidator.vue?vue&type=style&index=0&id=23dc5b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports